
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.6667 30L10 36.6667V30H16.6667ZM28.3334 10C30.5435 10 32.6631 10.878 34.2259 12.4408C35.7887 14.0036 36.6667 16.1232 36.6667 18.3333C36.6667 20.5435 35.7887 22.6631 34.2259 24.2259C32.6631 25.7887 30.5435 26.6667 28.3334 26.6667H11.6667C9.45657 26.6667 7.33695 25.7887 5.77415 24.2259C4.21135 22.6631 3.33337 20.5435 3.33337 18.3333C3.33337 16.1232 4.21135 14.0036 5.77415 12.4408C7.33695 10.878 9.45657 10 11.6667 10H28.3334Z","fill":"#16171F"}})])
          )
        }
      }
    